<template>
  <el-dialog
      :title="title"
      top="5vh"
      :close-on-click-modal="false"
      @close="isClear?clearAll():()=>{}"
      :visible.sync="dialogVisible" :width="width" :before-close="onClose">
    <!--    <div class="lj-edit-header">-->
    <!--    </div>-->
    <div class="lj-edit-body">
      <lj-edit-form v-if="dialogVisible" :disabled="disabled" :formItems="formData" ref="ljForm">
        <template v-for="data in formData" :slot="data.name" slot-scope="value">
          <slot :name="data.name" :data="value">
          </slot>
        </template>

      </lj-edit-form>
    </div>
    <span slot="footer" class="dialog-footer" v-if="!disabled">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="onSure" size="small">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: "editDialog",
  props: {
    formData: Array,
    width: String,
    title: String,
    isClear: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      disabled: false,
      dialogVisible: false,
    }
  }
  ,
  computed: {
    form() {
      return this.$refs.ljForm.formData
    }
  },
  methods: {
    // 展示事件
    show(type) {
      this.disabled = !!type;
      this.dialogVisible = true
      this.$forceUpdate();
    },
    //获取键对应值
    getData(name) {
      return this.form[name];
    },
    //关闭组件
    onClose(done){
      this.$emit("close",true)
      done()
    },
    close(){
      this.dialogVisible=false;
      this.$emit("close",true)
    },
    // 表单赋值
    setData(name, value) {
      return this.$refs.ljForm.setData(name, value)
    },
    clearAll() {
      this.$refs.ljForm.clearAll()
    },
    // 用对象设置form
    setAllDate(object) {

      return this.$refs.ljForm.setAllDate(object)
    },
    // 确定事件
    onSure() {
      this.$refs.ljForm.ruleForm().then(() => {
        this.$emit('sureBack', this.form);
        this.dialogVisible = false
      });
    }
  }
}
</script>

